import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { REGISTER, ROOT, PASSWORD_RESET, LOGIN, PROFILE, USER_PROFILE } from '../../../constants/routes';
import formik from './LogingForm';
import Loader from '../../../components/Loader';
import { useFormik } from 'formik';
import logoImg from '../../../images/logo.svg';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from '../../../reducers/auth/auth.selectors';
import { Form} from 'react-bootstrap';
import { EmailIcon, Locked, UserIcon } from '../../../components/Icons';
import FooterLinks from '../FooterLinks';
import ButtonComponent from '../../../components/generic-components/ButtonComponent';
import LoginRegisterHeader from '../../../components/generic-components/LoginRegisterHeader';
import LoginWithGoogle from '../../../components/generic-components/LoginWithGoogle';
import LoginTermsAndConditions from '../../../components/generic-components/LoginTermsAndConditions';
import LanguageSwitcher from 'components/SelectModal';
import { LanguageData } from 'utils/languageMockData';
import API from '../../../API';
import { getCurrentUser, loginUser } from 'reducers/auth/auth.actions';
import { getToken, setToken } from 'helpers';
import ShowIcon from '../../../images/show_password.svg';
import HideIcon from '../../../images/hide_password.svg';
import { Dropdown } from 'react-bootstrap';
import { LanguageArrow } from '../../../components/Icons';
import TextField from '@mui/material/TextField';
const Login = ({ style, formStyle, callback, logo, children }) => {
  const user = useSelector(selectAuthUser);
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const token = getToken();
  const urlParams = new URLSearchParams(window.location.search);
  const authToken = urlParams.get('auth_token');
  const isFromEmail = urlParams.get('reset');
  const isHebrew = localStorage.getItem('current_language') === 'he';
  const tokenFromStrorage = localStorage.getItem('token');
  const [languagesData, setLanguagesData] = useState([]);
  const [showPassword, setPasswordVisibility] = useState(false);


  const handleItemSelect = item => {
    let current_language = localStorage.getItem('current_language');
    if (current_language === item.id) return;
    if (item.id === 'he') {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    } else {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    }
    localStorage.setItem('current_language', item.id);
    i18n.changeLanguage(item.id.toLowerCase());
  };
  const successCallback = !!callback
    ? callback
    : () => {
      if (location.state && location.state.redirectUrl) {
        history.push(location.state.redirectUrl);
      } else {
        if (location.state != undefined && location.state.hasOwnProperty('id')) {

          history.push(`/u/${location.state.id}/${location.state.nick}`);
        }
        else {
          history.push(ROOT)
        }
      }
    };

  const { values, status, handleSubmit, errors, touched, handleChange, isSubmitting } = useFormik(
    formik({ dispatch, callback: successCallback })
  );
  useEffect(() => {
    const fetchCountries = () => {
      API.get(`languages`).then(res => {
        setLanguagesData(res);
      });
    };

    fetchCountries();

  }, []);

  useEffect(() => {
    if (!!isFromEmail) {
      return history.push(`/settings/account?reset=${isFromEmail}`);
    }
  }, [isFromEmail]);

  useEffect(() => {
    if (user) {
      if (location.state != undefined && location.state.hasOwnProperty('id')) {

        history.push(`/u/${location.state.id}/${location.state.nick}`);
      }
      else {
        history.push(ROOT)
      }
    }
  }, [user]);

  useEffect(() => {
    if (authToken && authToken.length > 0) {
      setToken(authToken);
      dispatch(getCurrentUser());
    }
  }, [token, authToken]);

  useEffect(() => {
    if (tokenFromStrorage && tokenFromStrorage.length > 0) {
      if (location.state != undefined && location.state.hasOwnProperty('id')) {

        history.push(`/u/${location.state.id}/${location.state.nick}`);
      }
      else {
        history.push(ROOT)
      }
    }
  }, [tokenFromStrorage]);
  return (
    <div className={`d-flex flex-column flex-fill pt-4 pb-5 background_dark login-container  + ${isHebrew ? "hebrew" : ""} `} style={{ ...style }}>
      <LoginRegisterHeader />
      <LoginWithGoogle />

      <Form noValidate className="login-form" style={formStyle} onSubmit={handleSubmit} autoComplete="on">
        <div className="d-flex flex-column mx-auto w-100 align-items-center login-form-wrapper">
          <Loader isLoadin={isSubmitting} height={280} size={60}>
            {status &&
              status.errors &&
              status.errors.map((err, key) => {
                if(err[0] === 'email.verify-mail') {
                  return <p key={key} className="login-verify-error">
                           {err[1]}
                         </p>
                } else {
                    return <p key={key} className="login-password-email-error">
                            {err[1]}
                          </p>
                       }
              })}
            <div className="form_wrap email-input">
              <TextField  
                fullWidth
                label={t(`Email`)}
                type="text"
                name="email"
                value={values.email}
                onChange={handleChange}
                isInvalid={touched.email && errors.email}
                />
                  <div className='warning-message' type="invalid" tooltip>
                      {touched.email && t(errors.email)}
                  </div>

              </div>
          
                <div className="form_wrap password-input">
                  <TextField  
                    fullWidth
                    label={t(`Password`)}
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    isInvalid={touched.password && errors.password}
                    inputProps={{style: {width: "88%"}}}
                    />
                  <div className="image-container" onClick={() => setPasswordVisibility(prevState => !prevState)}>
                      {showPassword ? <img src={HideIcon} /> : <img src={ShowIcon} />}
                  </div>
                    <div className='warning-message' type="invalid" tooltip>
                      {touched.password && t(errors.password)}
                    </div>
                </div>

                <div className="w-100  forgot-password-container">
                  <Link to={PASSWORD_RESET} className="ml-2">
                    <small>{t('forgot_password')}</small>
                  </Link>
                </div>

            <ButtonComponent
              btnText={t('sign_in')}
              transparent={false}
              customClass={'mt-5 mb-2 btn-gradient custom-sign-in-btn'}
            />
            <div className={'d-flex sign-up-here flex-column justify-content-center align-items-center mt-4'}>
              <p className={'sign-up-here font-size-12'}>
                {t('Sign up for Showit')}
                {'\u00A0'}
              </p>
              <Link to={REGISTER} className="font-weight-bold mt-2 text-light-gray">
                {t('Register')}
              </Link>
            </div>
          </Loader>
        </div>
      </Form>

      <LoginTermsAndConditions />
      <div className='language-picker' >
        <Dropdown>
          <Dropdown.Toggle>
            {localStorage.getItem('current_language') &&
              Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
              ? t(Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')).name)
              : 'English'}
            <div className='language-arrow'>
              <LanguageArrow />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {Object.values(languagesData).map(language => (
              <Dropdown.Item onClick={() => handleItemSelect(language)}>
                <label className="container">
                  <input
                    type="radio"
                    checked={
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')) &&
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
                        .name === language.name
                    }
                    name="radio"
                  />
                  <span className="checkmark"></span>
                </label>
                {t(language.name)}
              </Dropdown.Item>
            ))}
            <div className="shape"></div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default Login;